import { Component, OnInit, Input } from '@angular/core';
import { Corps } from 'app/models/corps';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CorpsService } from 'app/core/corps.service';
import { NotificationsService } from 'app/utils/notifications.service';

@Component({
  selector: 'app-ajout-corps',
  templateUrl: './ajout-corps.component.html',
  styleUrls: ['./ajout-corps.component.css']
})
export class AjoutCorpsComponent implements OnInit {

  @Input()
  corps:Corps;
  form: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private activeModal: NgbActiveModal,
    private notification: NotificationsService,
    private corpService:CorpsService
  ) { }

  ngOnInit() {
    this.initForm();
  }

  submitForm() {
    const valeur: any = this.form.value;

    console.log(valeur);
    this.corpService.create(valeur).subscribe(
      catheter => {
        if (this.corps) {
          this.notification.addToast(
            " Modification Réussi",
            "infos",
            "success"
          );
        } else {
          this.notification.addToast(
            " Crétion Réussi",
            "infos",
            "success"
          );
        }
      },
      error => {
        if (this.corps) {
          this.notification.addToast(
            "Erreur sur Modification",
            'Attention', 'error'
          );
        } else {
          this.notification.addToast(
            "Erreur sur Création",
            'Attention', 'error'
          );
        }
      }
    );

    this.activeModal.dismiss("cancelled by user");
  }


  public initForm() {
    if (this.corps) {
      this.form = this.formBuilder.group({
        libelle: [this.corps.libelle, Validators.required],
        etat: [this.corps.etat, Validators.required],
        id: [this.corps.id]
      });
    } else {
      this.form = this.formBuilder.group({
        libelle: [null, Validators.required],
        etat: [true],
        id: [null]
      });
    }
  }
  dismiss() {
    this.activeModal.dismiss("cancelled by user");
  }

}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/parametrage/corps/ajout-corps/ajout-corps.component.ts